import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { faChevronRight, faKeySkeleton } from '@fortawesome/pro-regular-svg-icons';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { Button, Select } from '@nazka/nazka.mapframe.components';

import { setSourceKey, setDistributionKey } from './key-selector.slice';

import './key-selector.css';

const sourceKeyOptions = [
  { label: 'Bronsleutel 1', id: '1' },
  { label: 'Bronsleutel 2', id: '2' },
  { label: 'Bronsleutel 3', id: '3' },
];

const distributionKeyOptions = [
  { label: 'Verdeelsleutel 1', id: '1' },
  { label: 'Verdeelsleutel 2', id: '2' },
  { label: 'Verdeelsleutel 3', id: '3' },
];

function KeySelector() {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const { sourceKey, distributionKey } = useSelector(state => state.keySelector);

  return (
    <div className={`key-selector${isOpen ? ' key-selector--open' : ''}`}>
      {!isOpen && (
        <Button
          className="key-selector__open"
          icon={faKeySkeleton}
          iconSize="14px"
          onClick={() => setIsOpen(true)}
        >
          {'Sleutel '}
          <span>{sourceKey?.id || sourceKey}</span>
          {' - '}
          <span>{distributionKey?.id || distributionKey}</span>
        </Button>
      )}
      {isOpen && (
        <div className="key-selector__content">
          <div className="key-selector__header">
            <p className="key-selector__header__title">
              Geselecteerde sleutels
            </p>
            <Button
              className="key-selector__close"
              icon={faChevronRight}
              iconSize="14px"
              onClick={() => setIsOpen(false)}
            />
          </div>
          <div className="key-selector__body">
            <Select
              className="key-selector__body__select"
              onInputChange={option => dispatch(setSourceKey(option.id))}
              toggleIcon={faCaretDown}
              options={sourceKeyOptions}
              value={sourceKey}
              placeholder="Bronsleutel..."
            />
            <Select
              className="key-selector__body__select"
              onInputChange={option => dispatch(setDistributionKey(option.id))}
              toggleIcon={faCaretDown}
              options={distributionKeyOptions}
              value={distributionKey}
              placeholder="Verdeelsleutel..."
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default KeySelector;
